import React from 'react';
import { UI_STYLES } from "../../styles/uiStyles";

interface AuthLinkProps {
  question: string;
  linkText: string;
  onClick: () => void;
  className?: string;
}

export const AuthLink: React.FC<AuthLinkProps> = ({
  question,
  linkText,
  onClick,
  className = ''
}) => {
  return (
    <div className={`text-center mt-8 flex flex-col items-center ${className}`}>
      <span className="text-white/60">{question}</span>
      <button
        type="button"
        onClick={onClick}
        className={`${UI_STYLES.emeraldTextColor} underline hover:${UI_STYLES.emeraldTextColor} transition  `}
      >
        {linkText}
      </button>
    </div>
  );
};

export default AuthLink; 
